import { h, Component } from 'preact';
import CurrencyMatrix from '../currency-matrix';
import StockSymbolTable from '../stock-symbol-table';
import Container from '../container';
import { QuoteHeader } from '../quote-header';
import { Select, Option, ContainerSize, containerSize, Header, DeviceVariance } from '@cube/blocks';
import style from './style';
import DynamicStockChart from '../dynamic-stock-chart';
import { Text } from 'preact-i18n';
import { SymbolLookup } from '@cube/finance-blocks';
import { LastUpdated } from '../stock-price-bar';
import { stockAPIStreamer } from '@os/cloudquote';
import cx from 'classnames';

function routeToSymbol(quote) {
	window.location = `/finance/category/stockdetail/symbol/${quote.UniqueSymbol}`;
}

export class MarketsPanel extends Component {

	state = { market: this.props.symbol, quote: [] };

	onData = (data) => {
		if (data && data.rows && data.rows.length) {
			this.setState({ quote: data.rows[0] });
		}
	};

	pickMarket = ({ value: market }) => {
		this.setState({ market });
		this.streamer = stockAPIStreamer(market, 'getStockPrice').on('data', this.onData);
	};

	generateSelect({ width, market, markets }) {
		return (
			<Select iconPosition="right" onChange={this.pickMarket} value={market} class={cx(style.marketSelect, width < 600 && style.marketSelectNarrow)} anchor="right">
				{ Object.keys(markets).map(key =>
					<Option title={markets[key]} value={key} />
				)}
			</Select>
		);
	}

	static defaultProps = {
		symbol: '$DJI',
		markets: {
			COMP: 'NASDAQ',
			$DJI: 'Dow Jones',
			SPX: 'S&P 500'
		}
	};

	componentWillMount() {
		this.streamer = stockAPIStreamer(this.props.symbol, 'getStockPrice').on('data', this.onData);
	}

	componentWillReceiveProps({ symbol }) {
		if (this.props.symbol !== symbol) {
			this.setState({ market: symbol });
		}
	}

	componentWillUnmount() {
		if (this.stream) this.streamer.end();
	}

	render({ width, markets, enableHeader, ...props }, { market, quote } ) {
		return (
			<Container class={cx(style.markets, width <= 500 && style.marketsNarrow, width > 500 && style.marketsWide)} parent>
				<DeviceVariance phone={false}>
					<ContainerSize height={false}>
						<QuoteHeader enableHeader={enableHeader} />
					</ContainerSize>
				</DeviceVariance>
				<SymbolLookup
					class={style.symbolLookup}
					onSymbolSelect={routeToSymbol}
					trackingSource="markets-panel/symbol-lookup"
					trackingZone="finance-components"
				/>

				{ markets && [
					<DeviceVariance
						phone={
							<Header transform="uppercase" title={<Text id="MARKETS">Markets</Text>}>
								{this.generateSelect({ width, market, markets })}
							</Header>
						}
						other={
							<div>
								<Header transform="uppercase" title={<Text id="MARKETS">Markets</Text>} />
								{this.generateSelect({ width, market, markets })}
							</div>
						}
					/>,
					<DynamicStockChart symbol={market} compare={false} />,
					<LastUpdated class={cx(style.hiddenOrBlock, width >= 600 && style.hiddenOrBlockWide)} quote={quote} {...props} />
				]}

				<Container class={style.sectors} title={<Text id="SECTORS">Sectors</Text>}>
					<StockSymbolTable
						showHeaders={['Sector', 'Price', 'Change %', '1 Month %', '3 Month %', '52 Week %']}
						symbols={['MSECTOR1', 'MSECTOR2', 'MSECTOR3', 'MSECTOR4', 'MSECTOR5', 'MSECTOR6', 'MSECTOR7', 'MSECTOR8', 'MSECTOR9']}
						columns={['name', 'price', 'changePercent', 'oneMonthChangePercent', 'threeMonthChangePercent', '52WeekChangePercent']}
					/>
					<StockSymbolTable
						showHeaders={['Sector','Price', 'Change %']}
						columns={[ 'name', 'price', 'changePercent' ]}
						symbols={['MSECTOR1', 'MSECTOR2', 'MSECTOR3', 'MSECTOR4', 'MSECTOR5', 'MSECTOR6', 'MSECTOR7', 'MSECTOR8', 'MSECTOR9']}
						cursor={0}
						trackingSource="markets-panel/sectors"
					/>
				</Container>
				<CurrencyMatrix transform="capitalize" />
				<Container class={style.worldMarkets} title={<Text id="WORLD_MARKETS">World Markets</Text>}>
					<StockSymbolTable
						showHeaders={['Index', '', 'Price', 'Change %']}
						columns={[ 'flag', 'name', 'price', 'changePercent' ]}
						symbols={['$FTSE','$PARI','$DAX','$N225','$HSI','$AOI','TSX:0000']}
						flags={['uk','france','germany','japan','hongkong','australia','canada']}
						cursor={0}
						trackingSource="markets-panel/world-markets"
					/>
				</Container>
			</Container>
		);
	}
}

export default containerSize({ height: false })(MarketsPanel);
